import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { ConstantsService } from '../../../../services/constants/constants.service';
import { WarningModalService } from '../../../../services/warning-modal/warning-modal.service';
import { AbstractModalComponent } from '../../../abstract-modal/abstract-modal.component';

@Component({
  selector: 'app-add-recipient-background-check-modal',
  templateUrl: './add-recipient-background-check-modal.component.pug',
  styleUrls: ['./add-recipient-background-check-modal.component.scss'],
  standalone: false
})
export class AddRecipientBackgroundCheckModalComponent extends AbstractModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('requestForm', {static: false}) requestForm: any;
  @Input() backgroundChecks: any;
  @Input() packageApiSettings: any = {};
  total = 0;
  errorMessage = {
    'type': '',
    'message': ''
  };
  errorTotalRefs = $localize`The number of total recipients for reference surveys cannot exceed 100. `
  internalReferenceTooltip = $localize`This is for internal records only and will not be shown to the candidate or referee.`
  recipient: any = {
    email: '',
    mobile_phone: '',
  };
  disableSend = true;
  saved = false;

  employmentSectorDropDownOptions = ConstantsService.EMPLOYMENT_SECTOR
  employmentTypeDropDownOptions = ConstantsService.EMPLOYMENT_TYPE
  acicBackgroundCheck = ConstantsService.ACIC_SHORT_NAME;
  nccpcBackgroundCheck = ConstantsService.NCC_PC_SHORT_NAME;
  nccmojBackgroundCheck = ConstantsService.NCC_MOJ_SHORT_NAME;
  nccbankruptcyBackgroundCheck = ConstantsService.NCC_BANKRUPTCY_SHORT_NAME;
  amlBackgroundCheck = ConstantsService.AML_SHORT_NAME;
  bannedBackgroundCheck = ConstantsService.BANNED_SHORT_NAME;
  ukdbsBackgroundCheck = ConstantsService.UKDBSC_SHORT_NAME;
  icrcBackgroundCheck = ConstantsService.ICRC_SHORT_NAME;
  cvsqBackgroundCheck = ConstantsService.CV_SQ_SHORT_NAME;
  cvBackgroundCheck = ConstantsService.CV_SHORT_NAME;
  edusqBackgroundCheck = ConstantsService.EDUV_SQ_SHORT_NAME;

  empsqBackgroundCheck = ConstantsService.EMPV_SQ_SHORT_NAME;
  empcpBackgroundCheck = ConstantsService.EMPV_CP_SHORT_NAME;
  eduvBackgroundCheck = ConstantsService.EDUV_SHORT_NAME;
  eduhlBackgroundCheck = ConstantsService.EDUV_HL_SHORT_NAME;
  employmentcoverage = _.cloneDeep(ConstantsService.EMPLOYMENT_COVERAGE);
  employmentQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  employmentQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationScopeOptions = _.cloneDeep(ConstantsService.CENTRIC_EDUCATION_SCOPE);
  selectEducationScope = $localize`Highest education`;
  trust1101Centric = false;
  trust1225Wwcc = false;
  trust1337DirectorshipCreditChecks = false;
  directorshipBackgroundCheck = ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME;
  directorshipCountries = ConstantsService.DIRECTORSHIP_COUNTRIES;
  directorshipCountryPlaceholder = ConstantsService.DIRECTORSHIP_COUNTRY_PLACEHOLDER;
  wwccWarningMessage = ConstantsService.WWCC_NSW_ACT_WARNING;
  wwccWarningIcon = 'https://assets.xref.com/omni/shared/error_amber.svg';
  flowsSelected: any = [];
  checkNames = {
    [this.acicBackgroundCheck] : ['role', 'hiring_organisation'],
    [this.ukdbsBackgroundCheck] : ['role', 'employment_sector'],
    [this.nccpcBackgroundCheck] : ['reason', 'place_work', 'type'],
    [this.nccmojBackgroundCheck] : ['reason', 'place_work', 'type'],
  };
  selectType = $localize`Select type`;
  emailOutOfFocus: boolean = false;
  mobileNumberTouched: boolean = false;
  yearOptions: { key: string; value: string }[] = [];
  fuzzinessOptions: { key: string; value: string }[] = ConstantsService.FUZZINESSOPTIONS;
  birthYearPlaceholder = ConstantsService.BIRTH_YEAR_PLACEHOLDER
  countryPlaceholder = ConstantsService.AML_COUNTRY_PLACEHOLDER
  fuzzinessToolTip = ConstantsService.FUZZINESS_TOOLTIP
  countryItems: any = []
  selectedItems = []
  fuzziness = 'Exact match';

  bgCheckShortNames: any = []; // Used for easier pug file checks status
  flowShortNames: any = [];
  template;

  // Used for faster look up in conditions
  selectedChecksMap = {
    [ConstantsService.ACIC_SHORT_NAME]: false,
    [ConstantsService.UKDBSC_SHORT_NAME]: false,
    [ConstantsService.ICRC_SHORT_NAME]: false,
    [ConstantsService.NCC_PC_SHORT_NAME]: false,
    [ConstantsService.NCC_MOJ_SHORT_NAME]: false,
    [ConstantsService.NCC_BANKRUPTCY_SHORT_NAME]: false,
    [ConstantsService.AML_SHORT_NAME]: false,
    [ConstantsService.BANNED_SHORT_NAME]: false,
    [ConstantsService.CV_SHORT_NAME]: false,
    [ConstantsService.CV_SQ_SHORT_NAME]: false,
    [ConstantsService.CV_HL_SHORT_NAME]: false,
    [ConstantsService.EDUV_SHORT_NAME]: false,
    [ConstantsService.EDUV_SQ_SHORT_NAME]: false,
    [ConstantsService.EDUV_HL_SHORT_NAME]: false,
    [ConstantsService.EMPV_SHORT_NAME]: false,
    [ConstantsService.EMPV_CP_SHORT_NAME]: false,
    [ConstantsService.EMPV_SQ_SHORT_NAME]: false,
    [ConstantsService.SMC_SHORT_NAME]: false,
    [ConstantsService.EIVC_SHORT_NAME]: false,
  }
  constructor(public _bsModalRef: BsModalRef,
    public modal: WarningModalService,
    private permissions: PermissionsService
  ) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.trust1101Centric = this.permissions.isFeatureActivated('trust-1101-centric');
    this.trust1225Wwcc = this.permissions.isFeatureActivated('trust-1225-certn-wwcc');
    this.trust1337DirectorshipCreditChecks = this.permissions.isFeatureActivated('trust-1337-directorship-credit-checks');
    if (this.trust1101Centric) {
      this.employmentcoverage = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYMENT_COVERAGE);
      this.employmentQuantityMin = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYERS_QUANTITY_MIN);
      this.employmentQuantityMax = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYERS_QUANTITY_MAX);
      this.credentialQuantityMin = _.cloneDeep(ConstantsService.CENTRIC_CREDENTIALS_QUANTITY_MIN);
      this.credentialQuantityMax = _.cloneDeep(ConstantsService.CENTRIC_CREDENTIALS_QUANTITY_MAX);
      this.checkNames = {
        ...this.checkNames,
        [this.icrcBackgroundCheck]: ['role', 'employment_sector'],
      };
    }
    if(this.template){
        this.recipient.internal_reference =  ''
    }

    this.bgCheckShortNames = this.backgroundChecks.map(check => check.short_name)
    this.bgCheckShortNames?.forEach(checkShortName => {
      if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
        this.selectedChecksMap[checkShortName] = true;
    })

    if(this.flowsSelected.length){
        this.flowShortNames = this.flowsSelected.map(check => check.short_name)
        this.flowShortNames?.forEach(checkShortName => {
            if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
              this.selectedChecksMap[checkShortName] = true;
        })
    }

    this.checkTotalRecipients();

    this.checkNames = {
        ...this.checkNames,
        [this.nccbankruptcyBackgroundCheck]: ['reason', 'place_work', 'type'],
    };
    this.checkNames = {
    ...this.checkNames,
    [this.cvsqBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'],
    ...(this.trust1101Centric ? { [this.cvBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'] } : {}),
    [this.edusqBackgroundCheck]: this.trust1101Centric ? ['verification_type'] : ['verification_qual_min', 'verification_qual_max'],
    [this.empsqBackgroundCheck]: ['verification_emp_min', 'verification_emp_max'],
    [this.empcpBackgroundCheck]: ['verification_years']
    };
    if (this.trust1337DirectorshipCreditChecks) {
      this.checkNames = {
        ...this.checkNames,
        [this.directorshipBackgroundCheck]: ['country'],
      };
    }

    if (this.selectedChecksMap[this.empcpBackgroundCheck]){
      this.recipient['verification_years'] = this.packageApiSettings?.[ConstantsService.EMPV_SHORT_NAME]?.verification_years ?? '5'
    }
    if (this.selectedChecksMap[this.empsqBackgroundCheck]){
      this.recipient['verification_emp_min'] = this.packageApiSettings?.[ConstantsService.EMPV_SHORT_NAME]?.verification_emp_min ?? '2'
      this.recipient['verification_emp_max'] = this.packageApiSettings?.[ConstantsService.EMPV_SHORT_NAME]?.verification_emp_max ?? '3'
    }
    if (this.trust1101Centric && this.isEducationVerificationSelected()){
      const verificationType = ConstantsService.normalizeEducationScope(
        this.recipient['verification_type']
          || this.packageApiSettings?.[ConstantsService.EDUV_SHORT_NAME]?.verification_type
          || this.educationScopeOptions[0].key
      );
      this.recipient['verification_type'] = verificationType;
      this.selectEducationScope = this.educationScopeOptions.find(option => option.key === verificationType)?.value
        ?? this.selectEducationScope;
    }
    else if (this.selectedChecksMap[this.edusqBackgroundCheck]){
      this.recipient['verification_qual_min'] = '1'
      this.recipient['verification_qual_max'] = '3'
    }
    if (this.isCredentialVerificationSelected()){
      this.recipient['verification_cred_min'] = this.packageApiSettings?.[ConstantsService.CV_SHORT_NAME]?.verification_cred_min ?? '1'
      this.recipient['verification_cred_max'] = this.packageApiSettings?.[ConstantsService.CV_SHORT_NAME]?.verification_cred_max ?? '3'
    }
    if (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck] || this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccmojBackgroundCheck])){
      this.recipient['type'] = this.employmentTypeDropDownOptions[0].key;
      this.selectType = this.employmentTypeDropDownOptions[0].value;
    }
    this.selectedItems = [];

    if(this.selectedChecksMap[this.amlBackgroundCheck]){
    const fuzziness = this.packageApiSettings?.[ConstantsService.AML_SHORT_NAME]?.fuzziness ?? 'exact_match'
    this.recipient['fuzziness'] = fuzziness
    this.fuzziness = this.fuzzinessOptions.find(option => option.key === fuzziness)?.value ?? this.fuzziness
    const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 1870; year--) {
        this.yearOptions.push({
          key: year.toString(),
          value: year.toString(),
        });
      }
    }

  }

  changeValue() {
    // making sure that either email or phone is entered before allowing data
    if (this.recipient.first_name?.trim() && this.recipient.last_name?.trim() && this.recipient.email && this.recipient.mobile_phone && (!(!!this.template) || (!!this.template && this.recipient.internal_reference?.trim()))) {
      this.checkRequiredFieldsForCheckName();
      this.checkTotalRecipients();
    } else this.disableSend = true;
  }

  changeValueAndCheckRoleLength() {
    // Validate the role length
    if (this.recipient.role.length > 255) {
      this.disableSend = true;
    }

    this.changeValue()
  }

  changeValueAndCheckHiringOrgLength() {
    if (this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccmojBackgroundCheck]) || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck]))
      this.recipient['place_work'] = this.recipient['hiring_organisation']

    if (!this.selectedChecksMap[this.acicBackgroundCheck])
      delete this.recipient['hiring_organisation']

    // Validate the place_work length
    if (this.recipient?.place_work?.length > 100) {
      this.disableSend = true;
    }
    this.changeValue()
  }

  changeValueAndCheckRoleReasonLength() {
    if (this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccmojBackgroundCheck]) || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck]))
      this.recipient['reason'] = this.recipient['role']

    if (!this.selectedChecksMap[this.acicBackgroundCheck] && !this.selectedChecksMap[this.ukdbsBackgroundCheck] && !(this.trust1101Centric && this.selectedChecksMap[this.icrcBackgroundCheck]))
      delete this.recipient['role']

    // Validate the role & reason length
    if (this.recipient?.reason?.length > 100 || this.recipient?.role?.length > 255) {
      this.disableSend = true;
    }
    this.changeValue()
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }


  addRecipient() {
    this.saved = true;
    if (!this.recipient.mobile_phone) this.recipient.country_code = '';
    let payload = this.recipient;
    if (this.recipient.first_name && this.recipient.last_name && this.recipient.email && this.recipient.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
      this.checkTotalRecipients();
      this.nextClick.emit({data: payload});
      this._bsModalRef.hide();
    }
  }

  checkRequiredFieldsForCheckName(){
    let fieldsToCheck = [...this.bgCheckShortNames, ...this.flowShortNames]
          .filter(checkName => Object.keys(this.checkNames).includes(checkName))
          .reduce((acc, checkName) => acc.concat(this.checkNames[checkName]), []);

    if (fieldsToCheck && fieldsToCheck.length > 0) {
      for (const fieldName of fieldsToCheck) {
        if (!this.recipient[fieldName] || this.recipient[fieldName]?.trim() === '') {
          this.disableSend = true;
          return;
        }
      }
    }

    if (this.selectedChecksMap[this.empsqBackgroundCheck]){
        const min = Number(this.recipient['verification_emp_min']);
        const max = Number(this.recipient['verification_emp_max']);
        if (min > max) {
            this.disableSend = true;
            return;
        }
  }
    if (this.selectedChecksMap[this.edusqBackgroundCheck]){
        const min = Number(this.recipient['verification_qual_min']);
        const max = Number(this.recipient['verification_qual_max']);
        if (min > max) {
            this.disableSend = true;
            return;
        }
    }
    if (this.isCredentialVerificationSelected()){
        const min = Number(this.recipient['verification_cred_min']);
        const max = Number(this.recipient['verification_cred_max']);
        if (min > max) {
            this.disableSend = true;
            return;
        }
    }

    this.disableSend = false;
  }

  getForm() {
    return this.requestForm;
  }

  phoneUpdate(event) {
    this.recipient.country_code = event['country_code'];
    this.recipient.mobile_phone = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];
    this.formDirty = true;
    this.changeValue();
  }

  checkTotalRecipients() {
    if (this.total >= ConstantsService.REFERENCE_RECIPIENTS_LIMIT) {
      this.disableSend = true;
      this.errorMessage = {
        'type': 'danger',
        'message': this.errorTotalRefs
      };
    }
  }

  dropDownOptionSelected(sector) {
    this.formDirty = true;
    this.recipient['employment_sector'] = sector.value;
    this.changeValue();
  }

  employmentCoverageSelected(sector) {
    this.formDirty = true;
    this.recipient['verification_years'] = sector.value;
    this.changeValue();
  }

  employmentQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_emp_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_emp_max'] = sector.value;
    }
    this.changeValue();
  }

  educationQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_qual_min'] = sector.value;
        this.recipient['verification_cred_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_qual_max'] = sector.value;
        this.recipient['verification_cred_max'] = sector.value;
    }
    this.changeValue();
  }

  isEducationVerificationSelected() {
    return this.selectedChecksMap[this.eduvBackgroundCheck]
      || this.selectedChecksMap[this.edusqBackgroundCheck]
      || this.selectedChecksMap[this.eduhlBackgroundCheck];
  }

  isCredentialVerificationSelected() {
    return (this.trust1101Centric && this.selectedChecksMap[this.cvBackgroundCheck])
      || this.selectedChecksMap[this.cvsqBackgroundCheck];
  }

  educationScopeSelected(scope) {
    this.formDirty = true;
    this.recipient['verification_type'] = scope.key;
    this.selectEducationScope = scope.value;
    this.changeValue();
  }

  credentialQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_cred_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_cred_max'] = sector.value;
    }
    this.changeValue();
  }

  employmentTypeOptionSelected(sector) {
    this.formDirty = true;
    this.recipient['type'] = sector.key;
    this.changeValue();
  }

  updateYear(year) {
    this.recipient['birth_year'] = year.value;
  }

  updatefuzziness(fuziness) {
    this.recipient['fuzziness'] = fuziness.key;
    this.fuzziness = fuziness.value;
  }

  directorshipCountrySelected($event) {
    this.recipient['country'] = $event.value;
    this.changeValue();
  }

  isBackgroundCheckSelected(checks) {
      return checks.some(bgCheck => this.bgCheckShortNames.includes(bgCheck)) || checks.some(bgCheck => this.flowShortNames.includes(bgCheck))
  }

  get showWwccWarning(): boolean {
    return this.trust1225Wwcc && this.isBackgroundCheckSelected([ConstantsService.WWCC_SHORT_NAME]);
  }

  selectedItemsEmitter($event){
    this.selectedItems = $event;
    this.recipient['country_codes'] = $event.map(item => item.value);

  }

  changeValueAndCheckForRoleLength() {
    if (this.recipient.internal_reference.length > 255) {
      this.disableSend = true;
    } else {
      this.changeValue()
    }
   }
}

